// Native haptic feedback helper.
// In the iOS Capacitor build this calls real Taptic Engine APIs.
// On the web (and on Android without the plugin) it's a silent no-op,
// so the same call site is safe everywhere.

import { Capacitor } from "@capacitor/core";

let HapticsModule = null;
let ImpactStyle = null;

// Lazy-load so the web bundle stays small if not on native.
const ensureLoaded = async () => {
  if (HapticsModule) return;
  try {
    const mod = await import("@capacitor/haptics");
    HapticsModule = mod.Haptics;
    ImpactStyle = mod.ImpactStyle;
  } catch {
    /* Not bundled — no-op */
  }
};

const isNative = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const tap = async (style = "light") => {
  if (!isNative()) return;
  await ensureLoaded();
  if (!HapticsModule) return;
  const lookup = {
    light: ImpactStyle?.Light,
    medium: ImpactStyle?.Medium,
    heavy: ImpactStyle?.Heavy,
  };
  try {
    await HapticsModule.impact({ style: lookup[style] ?? ImpactStyle?.Light });
  } catch {
    /* swallow */
  }
};

export const success = async () => {
  if (!isNative()) return;
  await ensureLoaded();
  if (!HapticsModule) return;
  try {
    await HapticsModule.notification({ type: "SUCCESS" });
  } catch {
    /* swallow */
  }
};

export const selection = async () => {
  if (!isNative()) return;
  await ensureLoaded();
  if (!HapticsModule) return;
  try {
    await HapticsModule.selectionStart();
    await HapticsModule.selectionChanged();
    await HapticsModule.selectionEnd();
  } catch {
    /* swallow */
  }
};
